import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FacebookLike extends Component {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        //debugger;
        if(window.FB && window.FB.XFBML) {
            window.FB.XFBML.parse($("#fblike")[0]);
        }
    }

    render() {        
        return (
            <div id="fblike" className="btn-likeflw">
                <div className="fb-like" 
                    data-href={this.props.url}
                    data-layout={this.props.dataLayout ? this.props.dataLayout : 'button'} 
                    data-action="like" 
                    data-show-faces={this.props.showFaces ? true : false} />
            </div>                                                            
        );
    }
}

FacebookLike.propTypes = {
    url: PropTypes.string.isRequired,
    dataLayout: PropTypes.string,
    showFaces: PropTypes.bool
};

export default FacebookLike;
